import { getTokenOrigin } from 'utilities';
import { AbstractHandler } from '../../interfaces/handler.interface';
import { TokenSetupPayload } from '../../interfaces/host-message-payloads.types';

export class TokenOriginHandler extends AbstractHandler<TokenSetupPayload> {
  override handle(request: TokenSetupPayload): string | null {
    if (!request.host && request.token) {
      const origin = getTokenOrigin(request.token);
      return origin;
    }

    return super.handle(request);
  }
}
